import React, { useState } from "react";

function Edd() {
  const [menstrual, setMenstrual] = useState("");
  const [cycle, setCycle] = useState("");
  const [luteal, setLuteal] = useState("");
  const [conception, setConception] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [fetalAge, setFetalAge] = useState("");
  const [cycleError, setCycleError] = useState("");
  const [lutealError, setLutealError] = useState("");

  const handleCycleChange = (e) => {
    const value = e.target.value;
    
    // Allow only numbers and empty string
    if (value === "" || /^\d+$/.test(value)) {
      setCycle(value);
      
      // Real-time validation
      if (value !== "") {
        const numValue = parseInt(value);
        if (numValue < 22 || numValue > 45) {
          setCycleError("Cycle length must be between 22 and 45 days");
        } else {
          setCycleError("");
        }
      } else {
        setCycleError("");
      }
    }
  };

  const handleLutealChange = (e) => {
    const value = e.target.value;
    
    // Allow only numbers and empty string
    if (value === "" || /^\d+$/.test(value)) {
      setLuteal(value);
      
      // Real-time validation
      if (value !== "") {
        const numValue = parseInt(value);
        if (numValue < 9 || numValue > 17) {
          setLutealError("Luteal phase length must be between 9 and 17 days");
        } else {
          setLutealError("");
        }
      } else {
        setLutealError("");
      }
    }
  };

  function pregnancyCalc() {
    // Check if required fields are filled
    if (!menstrual) {
      alert("Please enter the first day of your last menstrual period.");
      return;
    }
    
    if (!cycle) {
      alert("Please enter your average cycle length.");
      return;
    }
    
    if (!luteal) {
      alert("Please enter your average luteal phase length.");
      return;
    }
    
    // Check if there are any validation errors
    if (cycleError || lutealError) {
      alert("Please fix the validation errors before calculating.");
      return;
    }
    
    // Check if date is not in the future
    const menstrualInput = new Date(menstrual);
    const today = new Date();
    if (menstrualInput > today) {
      alert("Please enter a date that is not in the future.");
      return;
    }

    const cycleValue = parseInt(cycle);
    const lutealValue = parseInt(luteal);

    if (cycleValue < 22 || cycleValue > 45) {
      alert("Cycle length must be between 22 and 45 days.");
      return;
    }

    if (lutealValue < 9 || lutealValue > 17) {
      alert("Luteal phase length must be between 9 and 17 days.");
      return;
    }

    const ovulation = new Date(
      menstrualInput.getTime() + cycleValue * 86400000 - lutealValue * 86400000
    );

    setConception(dispDate(ovulation));

    const duedate = new Date(ovulation.getTime() + 266 * 86400000);
    setDueDate(dispDate(duedate));

    const fetalage = 14 + 266 - (duedate - new Date()) / 86400000;
    const weeks = parseInt(fetalage / 7);
    const days = Math.floor(fetalage % 7);

    setFetalAge(`${weeks} week${weeks > 1 ? "s" : ""}, ${days} days`);
  }
  
  function dispDate(dateObj) {
    var month = dateObj.getMonth() + 1;
    month = month < 10 ? "0" + month : month;

    var day = dateObj.getDate();
    day = day < 10 ? "0" + day : day;

    var year = dateObj.getFullYear();

    return month + "/" + day + "/" + year;
  }
  
  // Set maximum date to today
  const today = new Date();
  const maxDate = today.toISOString().split('T')[0];
  
  // CSS styles for the button
  const buttonStyle = {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease'
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3' 
  };
  
  return (
    <>
      <div id="pregnancy_due_date_calc" role="tabpanel">
        <div className="row mt-2">
          <div className="col-md-6">
            <h3>Expected Date of Delivery (EDD)</h3>
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              The expected date of delivery (EDD), or due date, is the estimated date when your baby is most likely to be born. You can easily calculate it by using this pregnancy due date calculator. Just enter the first day of your last menstrual period (LMP) below, and you will get an estimate of your due date.
            </p>
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              On average, pregnancy lasts 280 days (40 weeks) from the first day of the last menstrual period (LMP).
            </p>
            
            <div className="clearfix">
              <br />
            </div>
            
            <h4 style={{fontSize:"22px"}}>Due Date Calculator Formulas</h4>
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              Using LMP (Last Menstrual Period):
            </p>
            <p>
              <strong>Formula 1: Due Date = LMP + 280 days (40 weeks)</strong>
            </p>
            <p>
              <strong>Formula 2 (Naegele's Rule): Due Date = LMP + 7 days – 3 months + 1 year</strong>
            </p>
            
            <h5>⚠️ Important Note</h5>
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              These methods provide an estimate, not an exact prediction.
            </p>
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              Only about 5% of babies are born exactly on their due date.
            </p>
            <p style={{ fontSize: "16px", textAlign: "justify" }}>
              Early ultrasound in the first trimester is considered the most accurate method for confirming your due date and is often used by doctors for precise monitoring.
            </p>
          </div>
          <div className="col-md-6">
            <div style={{ width: "100%" }}>
              <div className="body-fat-ratio-heading">
                <h5> Due Date Calculator</h5>
              </div>

              <div style={{ backgroundColor: "#F7F7F7" }}>
                <div className="clearfix">
                  <br />
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    pregnancyCalc();
                  }}
                  id="pregnancy_due_date_form"
                  style={{
                    width: "100%",
                    padding:"0px 15px",
                    marginTop: "20px",
                  }}
                >
                  <div className="row" style={{ borderBottom: "0px" }}>
                    <div className="col-lg-12 mb-3">
                      <label
                        className="control-label mb-10"
                        htmlFor="menstrual"
                      >
                        Last Menstrual Period
                      </label>
                      <input
                        type="date"
                        name="menstrual"
                        id="menstrual"
                        className="form-control"
                        value={menstrual}
                        max={maxDate}
                        onChange={(e) => setMenstrual(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label
                        className="control-label mb-10"
                        htmlFor="cycle"
                      >
                        Average Length of Cycles{" "}
                      </label>
                      <input
                        type="text"
                        name="cycle"
                        id="cycle"
                        placeholder="22 to 45"
                        value={cycle}
                        className={`form-control mb-0 ${cycleError ? 'is-invalid' : ''}`}
                        onChange={handleCycleChange}
                        onKeyPress={(e) => {
                          // Allow only numbers
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        required
                      />
                      {cycleError && <div style={{lineHeight:"18px"}} className="text-danger small mt-1">{cycleError}</div>}
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label
                        className="control-label"
                        htmlFor="luteal"
                      >
                        Average Luteal Phase Length
                      </label>
                      <input
                        type="text"
                        name="luteal"
                        id="luteal"
                         placeholder="9 to 17"
                        value={luteal}
                        className={`form-control mb-0 ${lutealError ? 'is-invalid' : ''}`}
                        onChange={handleLutealChange}
                        onKeyPress={(e) => {
                          // Allow only numbers
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        required
                      />
                      {lutealError && <div style={{lineHeight:"18px"}} className="text-danger small mt-1">{lutealError}</div>}
                    </div>
                    
                    {/* Added spacing before the button */}
                    <div className="col-lg-12 mb-4" style={{ marginTop: '15px' }}>
                      <button 
                        type="submit" 
                        className=" calculate "
                        disabled={cycleError || lutealError}
                        // style={buttonStyle}
                        // onMouseOver={(e) => {
                        //   e.target.style.backgroundColor = buttonHoverStyle.backgroundColor;
                        // }}
                        // onMouseOut={(e) => {
                        //   e.target.style.backgroundColor = buttonStyle.backgroundColor;
                        // }}
                      >
                        Calculate
                      </button>
                    </div>
                    
                    <div className="col-lg-12 mb-3">
                      <label
                        className="control-label mb-10"
                        htmlFor="conception"
                      >
                        Estimated Conception:
                      </label>
                      <input
                        type="text"
                        name="conception"
                        id="conception"
                        value={conception}
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label
                        className="control-label mb-10"
                        htmlFor="duedate"
                      >
                        Estimated Due Date:
                      </label>
                      <input
                        type="text"
                        name="duedate"
                        id="duedate"
                        value={dueDate}
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="col-lg-12">
                      <label
                        className="control-label mb-10"
                        htmlFor="fetalage"
                      >
                        Estimated Fetal Age:
                      </label>
                      <input
                        type="text"
                        name="fetalage"
                        id="fetalage"
                        value={fetalAge}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edd;